import { Component } from '@angular/core';
import { BaseComponent } from '../../base/base.component';
import { ToolbarEventManagerHelper } from './../../../services/event-managers/toolbar-event-manager.helper';

@Component({
  selector: 'app-wiki-export-pdf',
  templateUrl: './wiki-export-pdf.component.html',
  styleUrl: './wiki-export-pdf.component.scss',
  standalone: false,
})
export class WikiExportPdfComponent extends BaseComponent {
  constructor(private toolbarEventManagerHelper: ToolbarEventManagerHelper) {
    super();
  }

  public onExportPdf(): void {
    this.toolbarEventManagerHelper.WikiToolbarExportPdf = true;
  }
}
